import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslation } from "react-i18next";

export const ServiceAccountStatusTooltip = () => {
  const { t } = useTranslation();

  return (
    <Tooltip
      placement={"right"}
      title={
        <>
          <div style={{ color: "#60bc60" }}>
            <strong>
              {t(
                "pages.service-accounts.service-accounts-table.status-type.verified",
              )}
              :
            </strong>{" "}
            {t(
              "pages.service-accounts.service-accounts-table.status-type-info.verified",
            )}
          </div>
          <div style={{ color: "#fd6a6c" }}>
            <strong>
              {t(
                "pages.service-accounts.service-accounts-table.status-type.invalid",
              )}
              :
            </strong>{" "}
            {t(
              "pages.service-accounts.service-accounts-table.status-type-info.invalid",
            )}
          </div>
          <div style={{ color: "#63a7fd" }}>
            <strong>
              {t(
                "pages.service-accounts.service-accounts-table.status-type.processing",
              )}
              :
            </strong>{" "}
            {t(
              "pages.service-accounts.service-accounts-table.status-type-info.processing",
            )}
          </div>
        </>
      }
    >
      <InfoCircleOutlined style={{ marginLeft: "3%" }} />
    </Tooltip>
  );
};
